module.exports=function(scope){ return `dependencies {
  compile 'com.facetec:zoom-authentication:+@aar'
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/00-gradle-config.java.tpl